import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`to{transform:rotate(360deg);}`;
const shimmer = keyframes`0%{background-position:200% 0;}100%{background-position:-200% 0;}`;

const Wrapper = styled.div`
  display:flex;flex-direction:column;align-items:center;padding:40px 0;gap:12px;
`;
const Spinner = styled.div`
  width:36px;height:36px;border-radius:50%;
  border:3px solid ${p => p.theme.colors.border};
  border-top-color:${p => p.theme.colors.primary};
  animation:${spin} 0.8s linear infinite;
`;
const Message = styled.div`
  font-size:${p => p.theme.typography.sizes.sm};
  color:${p => p.theme.colors.text.secondary};
`;
const Block = styled.div`
  width:${p => p.$w || '100%'};height:${p => p.$h || '20px'};
  border-radius:${p => p.$round ? '50%' : `${p.theme.radius.sm}px`};
  margin:6px auto;
  background:linear-gradient(90deg,${p => p.theme.colors.background} 25%,${p => p.theme.colors.border} 50%,${p => p.theme.colors.background} 75%);
  background-size:200% 100%;animation:${shimmer} 1.5s infinite;
`;

function renderSkeleton(v) {
  switch (v) {
    case 'chart':
      return <><Block $w="200px" $h="200px" /><Block $w="150px" $h="12px" /><Block $w="100px" $h="12px" /></>;
    case 'table':
      return <><Block $w="100%" $h="16px" />{[...Array(6)].map((_, i) =>
        <Block key={i} $w={`${70 + i * 5}%`} $h="14px" />)}</>;
    case 'score':
      return <><Block $w="120px" $h="120px" $round /><Block $w="80px" $h="14px" /></>;
    case 'timeline':
      return <>{[0, 0, 20, 20, 40, 20].map((ml, i) =>
        <Block key={i} $w={`${60 + i * 6}%`} $h="14px" style={{ marginLeft: ml }} />)}</>;
    default:
      return <><Block $w="60%" $h="24px" /><Block $w="100%" $h="200px" /><Block $w="80%" $h="16px" /></>;
  }
}

export default function LoadingState({ loading, message = 'Computing...', skeleton = false, variant }) {
  if (!loading) return null;
  const showSkeleton = variant || skeleton;
  if (showSkeleton) {
    return <Wrapper role="status" aria-live="polite">{renderSkeleton(variant || 'default')}</Wrapper>;
  }
  return (
    <Wrapper role="status" aria-live="polite">
      <Spinner aria-hidden="true" />
      <Message>{message}</Message>
    </Wrapper>
  );
}
